import { ChevronLeftIcon, } from "@heroicons/react/24/outline"; // Heroicons v2
import createIcon from "./createIcon";

const KeyboardArrowLeft = createIcon(ChevronLeftIcon, "KeyboardArrowLeft");

export default KeyboardArrowLeft;
